@if (!loading && data.title) {
  <h1 mat-dialog-title>{{data.title | translate}}</h1>
}
@if (loading) {
  <h1 mat-dialog-title>{{'Recupero dati in corso' | translate}}</h1>
}
<mat-dialog-content>

  @if (!loading) {
    @switch (data.component) {
      @case ("trip-package-overview") {
        <trip-package-overview
        ></trip-package-overview>
      }
    }
  }

  @if (loading) {
    <div class="spinner fx-row fx-justify-center fx-items-center">
      <mat-spinner></mat-spinner>
    </div>
  }

</mat-dialog-content>

@if (!loading) {
  <mat-dialog-actions align='end'>
    <button mat-flat-button (click)='onYesClick()' color='accent' >{{data.positiveText?data.positiveText:'chiudi' | translate}}</button>
  </mat-dialog-actions>
}
